export default __webpack_public_path__ + "static/media/Boeing.a34491a7.png";